import { atom } from "jotai";

// seatGatedAtom is set true when ANY API call to the current galaxy returns
// 402 needs_seat — a private-mode galaxy whose observations require a paid seat
// (PUBLIC_GALAXY_OPEN_VIEW). The api layer sets it (getDefaultStore) from
// request(); Layout reads it to render the full-page SeatGate instead of the
// galaxy view, and clears it when the active galaxy (URL :account) changes so
// switching to a public/seated galaxy drops the gate.
export const seatGatedAtom = atom(false);
